import { SUBMIT_SALESFORCE_TICKET } from './constants';

const submitSalesforceTicket = value => ({
  type: SUBMIT_SALESFORCE_TICKET,
  value
});

export { submitSalesforceTicket };
